// user-dashboard/components/StaffAddTmEmailForm.jsx
import React, { useEffect, useState } from "react";
import { completeTmAccountRequest } from "../../../api";
import { isUseSameDetails } from "../../../shared/tmAccountRequest";

export default function StaffAddTmEmailForm({ record, request, onCreated }) {
  const sameDetails = isUseSameDetails(request);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [dob, setDob] = useState("");
  const [address, setAddress] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    setEmail("");
    setPassword("");
    setFullName("");
    setDob("");
    setAddress("");
    setError("");
    setSuccess("");
  }, [record?.id, request?.id, sameDetails]);

  const canSubmit = sameDetails
    ? !!email.trim()
    : !!email.trim() &&
      !!password.trim() &&
      !!fullName.trim() &&
      !!dob &&
      !!address.trim();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit || !request?.id) return;
    setError("");
    setSuccess("");
    setSubmitting(true);
    try {
      const created = await completeTmAccountRequest(request.id, {
        email: email.trim(),
        ...(sameDetails
          ? {}
          : {
              password: password.trim(),
              full_name: fullName.trim(),
              dob,
              address: address.trim(),
            }),
      });
      setSuccess(`Created ${created?.new_email || email.trim()}`);
      setEmail("");
      setPassword("");
      setFullName("");
      setDob("");
      setAddress("");
      await onCreated?.(created);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(
        (typeof detail === "string" && detail) ||
          err?.message ||
          "Failed to create email"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-3 pt-3 border-top">
      <div className="fw-semibold mb-2">Add new email</div>
      <p className="small text-muted mb-2">
        {sameDetails
          ? "Buyer asked to use the same details. Enter the new email only; site, password, name, DOB, and address will be copied from the existing account."
          : "Buyer did not use the same details. Enter the new email, password, full name, date of birth, and address."}
      </p>
      {error && <div className="alert alert-danger py-2 small">{error}</div>}
      {success && <div className="alert alert-success py-2 small">{success}</div>}
      <div className="mb-2">
        <label className="form-label small mb-1">
          New email <span className="text-danger">*</span>
        </label>
        <input
          type="email"
          className="form-control form-control-sm"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={submitting}
          placeholder="new@example.com"
        />
      </div>
      {!sameDetails && (
        <>
          <div className="mb-2">
            <label className="form-label small mb-1">
              Password <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={submitting}
            />
          </div>
          <div className="mb-2">
            <label className="form-label small mb-1">
              Full name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              disabled={submitting}
            />
          </div>
          <div className="mb-2">
            <label className="form-label small mb-1">
              Date of birth <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              required
              disabled={submitting}
            />
          </div>
          <div className="mb-2">
            <label className="form-label small mb-1">
              Address <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control form-control-sm"
              rows={2}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
              disabled={submitting}
            />
          </div>
        </>
      )}
      <button
        type="submit"
        className="btn btn-primary btn-sm"
        disabled={!canSubmit || submitting || !request?.id}
      >
        {submitting ? "Creating…" : "Create email"}
      </button>
    </form>
  );
}
